import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormKeys } from '../types';

export const CostPerSaleReferralField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();

  return (
    <TextField
      rightSection="%"
      placeholder="0"
      title={t('TextForm.Commission rate')}
      help={t('Tooltip.Commission rate help')}
      name={MarketplaceFormKeys.costPerSaleReferral}
      {...props}
    />
  );
};
